"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIErrorClasses = void 0;
const tslib_1 = require("tslib");
const apiErrors = (0, tslib_1.__importStar)(require("./Errors"));
exports.APIErrorClasses = Object.values(apiErrors);
